import { api } from "./axiosClient";
import type { ClauseType } from "../types/clauseType.types";
import { getCurrentUser } from "../auth/auth.service";

export const clauseTypesApi = {
  searchClauseTypes: async (payload: any) => {
    const response = await api.post("/clauseType/search", payload);
    return response.data;
  },

  createClauseType: async (data: Partial<ClauseType>) => {
    const response = await api.post("/clauseType/create", data);
    return response.data;
  },

  updateClauseType: async (data: Partial<ClauseType>) => {
    const response = await api.post("/clauseType/edit", data);
    return response.data;
  },

  removeClauseType: async (id: string) => {
    return await api.post("/clauseType/remove", { id });
  },

  activateClauseType: async (id: string) => {
    return await api.post("/clauseType/activate", { id });
  },

  deactivateClauseType: async (id: string) => {
    return await api.post("/clauseType/deactivate", { id });
  },
};

export interface ClauseTypeOption {
  id: string;
  name: string;
  isActive: boolean;
}

/**
 * The caller's organisation's clause types, sorted by name, for the Clause
 * Library's filters. Inactive ones are included unless `activeOnly`: older
 * clauses may still carry them. Failure-tolerant: an empty list just leaves
 * the filter empty.
 */
export async function listClauseTypeOptions(
  opts: { activeOnly?: boolean } = {},
): Promise<ClauseTypeOption[]> {
  try {
    const me = await getCurrentUser();
    const res = await clauseTypesApi.searchClauseTypes({
      pageSize: 200,
      pageIndex: 0,
      searchText: "",
      groupIds: [`${me?.companyId}`],
      includeDeleted: false,
      ...(opts.activeOnly ? { isActive: true } : {}),
    });
    const rows = (res?.data ?? res?.items ?? []) as ClauseType[];
    return rows
      .filter((r) => r?.id && r.clauseName)
      .map((r) => ({ id: r.id, name: r.clauseName, isActive: r.isActive !== false }))
      .sort((a, b) => a.name.localeCompare(b.name));
  } catch {
    return [];
  }
}
